var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    transform: "translate(-863 -414)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_359",
    "data-name": "Ellipse 359",
    cx: 55,
    cy: 55,
    r: 55,
    transform: "translate(863 414)",
    fill: "#ff4733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "voice",
    d: "M26.832,55.609v4.713H34.5a3.536,3.536,0,0,1,2.7,1.245A4.328,4.328,0,0,1,38.332,64.6a4.525,4.525,0,0,1-1.107,3.064A3.468,3.468,0,0,1,34.5,68.939h-23A3.471,3.471,0,0,1,8.774,67.66,4.514,4.514,0,0,1,7.666,64.6a4.407,4.407,0,0,1,1.107-3.029A3.5,3.5,0,0,1,11.5,60.322h7.666V55.609A21.987,21.987,0,0,1,5.481,46.89,26.77,26.77,0,0,1,0,30.161a4.478,4.478,0,0,1,1.107-3.029,3.468,3.468,0,0,1,2.726-1.279,3.468,3.468,0,0,1,2.726,1.279,4.478,4.478,0,0,1,1.107,3.029,17.691,17.691,0,0,0,4.492,12.185,14.16,14.16,0,0,0,21.68,0,17.7,17.7,0,0,0,4.492-12.185,4.408,4.408,0,0,1,1.138-3.029A3.527,3.527,0,0,1,42.2,25.852a3.437,3.437,0,0,1,2.7,1.279A4.478,4.478,0,0,1,46,30.161,26.77,26.77,0,0,1,40.517,46.89,21.987,21.987,0,0,1,26.832,55.609ZM23,43.087a10.5,10.5,0,0,1-8.145-3.771A13.3,13.3,0,0,1,11.5,30.161V12.926a13.285,13.285,0,0,1,3.354-9.155,10.683,10.683,0,0,1,16.29,0A13.294,13.294,0,0,1,34.5,12.926V30.161a13.285,13.285,0,0,1-3.354,9.155A10.516,10.516,0,0,1,23,43.087Z",
    transform: "translate(895.001 434.531)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.71ee8d8956d0f111224f27b23562972a.svg";
export { ForwardRef as ReactComponent };